module.exports = __webpack_public_path__ + "static/img/dc-logo-powered-by-dc-white.87954e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dc-logo-powered-by-dc-white.svg
// module id = 2497
// module chunks = 0